import React from 'react';
import { XIcon } from 'lucide-react';
interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TermsModal({
  isOpen,
  onClose
}: TermsModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4 backdrop-blur-sm" data-id="element-381">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col" data-id="element-382">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between" data-id="element-383">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-384">
            Términos y Condiciones
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-50 rounded-lg" data-id="element-385">
            <XIcon className="h-5 w-5" data-id="element-386" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto p-6 space-y-5 text-sm text-gray-600 leading-relaxed" data-id="element-387">
          <div className="text-center mb-6" data-id="element-388">
            <h3 className="text-lg font-bold text-gray-900" data-id="element-389">
              Términos y Condiciones de Uso Tarjeta CLUBAHORRA
            </h3>
          </div>

          <section data-id="element-390">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-391">
              1. NATURALEZA DEL PROGRAMA
            </h4>
            <p data-id="element-392">
              El presente documento establece los términos y condiciones
              aplicables al uso de la tarjeta de fidelización gratuita
              denominada CLUBAHORRA (en adelante, "la Tarjeta"), la cual permite
              a sus titulares acceder a beneficios, descuentos y promociones
              ofrecidos por comercios afiliados al programa.
            </p>
          </section>

          <section data-id="element-393">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-394">
              2. ACCESO A LA TARJETA
            </h4>
            <ul className="list-disc pl-5 space-y-2" data-id="element-395">
              <li data-id="element-396">
                La Tarjeta es gratuita y de uso personal e intransferible.
              </li>
              <li data-id="element-397">
                Podrá acceder a ella cualquier persona natural mayor de edad que
                complete el formulario de afiliación correspondiente.
              </li>
              <li data-id="element-398">
                El uso de la Tarjeta implica la aceptación plena de estos
                términos y condiciones.
              </li>
            </ul>
          </section>

          <section data-id="element-399">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-400">
              3. BENEFICIOS Y PROMOCIONES
            </h4>
            <ul className="list-disc pl-5 space-y-2" data-id="element-401">
              <li data-id="element-402">
                Los beneficios ofrecidos pueden incluir: descuentos directos,
                promociones especiales, servicios preferenciales, obsequios u
                otros incentivos, según lo determine cada comercio afiliado.
              </li>
              <li data-id="element-403">
                Cada comercio es el único responsable de aplicar, mantener,
                modificar o cancelar los beneficios que ofrece a los usuarios de
                la Tarjeta.
              </li>
              <li data-id="element-404">
                Los beneficios están sujetos a condiciones particulares propias
                de cada comercio (vigencia, stock, montos mínimos de compra,
                restricciones, etc.).
              </li>
            </ul>
          </section>

          <section data-id="element-405">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-406">
              4. RESPONSABILIDAD DEL PROGRAMA
            </h4>
            <ul className="list-disc pl-5 space-y-2" data-id="element-407">
              <li data-id="element-408">
                TicketMaestro SAS, empresa procesadora de la plataforma Benefika
                y de La Tarjeta, actúa únicamente como intermediario que conecta
                a los usuarios con comercios aliados, sin asumir responsabilidad
                por la calidad, disponibilidad o condiciones de los productos o
                servicios ofrecidos.
              </li>
              <li data-id="element-409">
                En caso de cualquier inconveniente o reclamo relacionado con los
                beneficios, el usuario deberá comunicarse directamente con el
                comercio correspondiente.
              </li>
            </ul>
          </section>

          <section data-id="element-410">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-411">
              5. VIGENCIA Y MODIFICACIONES
            </h4>
            <ul className="list-disc pl-5 space-y-2" data-id="element-412">
              <li data-id="element-413">
                La vigencia de la Tarjeta es indefinida, salvo que el usuario o
                la organización emiten renuncien expresamente a su uso.
              </li>
              <li data-id="element-414">
                La organización se reserva el derecho de modificar, suspender o
                cancelar el programa o sus términos y condiciones, informando
                oportunamente a los usuarios a través de sus canales oficiales.
              </li>
            </ul>
          </section>

          <section data-id="element-415">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-416">
              6. PROTECCIÓN DE DATOS PERSONALES
            </h4>
            <ul className="list-disc pl-5 space-y-2" data-id="element-417">
              <li data-id="element-418">
                Al afiliarse, el usuario autoriza el tratamiento de sus datos
                personales conforme a la legislación vigente, exclusivamente
                para fines informativos y promocionales relacionados con el
                programa.
              </li>
              <li data-id="element-419">
                Los datos no serán compartidos con terceros sin consentimiento
                del titular, salvo requerimiento legal. Puede ver más detalles
                en el documento de nuestras Políticas de Privacidad y Protección
                de Datos Personales.
              </li>
            </ul>
          </section>

          <section data-id="element-420">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-421">
              7. USO INDEBIDO Y CANCELACIÓN
            </h4>
            <ul className="list-disc pl-5 space-y-2" data-id="element-422">
              <li data-id="element-423">
                El uso fraudulento, indebido o contrario a estos términos puede
                dar lugar a la anulación inmediata de la Tarjeta y la pérdida de
                sus beneficios.
              </li>
              <li data-id="element-424">
                La organización podrá retirar o suspender la tarjeta en caso de
                mal uso sin necesidad de notificación previa.
              </li>
            </ul>
          </section>

          <section data-id="element-425">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-426">8. VIGENCIA</h4>
            <p data-id="element-427">
              La vigencia de estos Términos y Condiciones de Uso es desde el 12
              de septiembre de 2025 y permanecerá vigente hasta que exista una
              nueva versión que la reemplace.
            </p>
          </section>

          <div className="pt-4 border-t border-gray-200 text-xs text-gray-500" data-id="element-428">
            Última actualización: 12 de septiembre de 2025
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-100 px-6 py-4 bg-gray-50" data-id="element-429">
          <button onClick={onClose} className="w-full bg-brand-600 text-white py-3 rounded-lg font-semibold hover:bg-brand-700 transition-colors" data-id="element-430">
            Entendido
          </button>
        </div>
      </div>
    </div>;
}